// oxlint-disable no-bitwise

export function createHash(input: string): number {
    if (input === "") {
        return 0;
    }

    let hash = 0;

    for (let i = 0; i < input.length; i++) {
        const char = input.codePointAt(i) ?? 0;
        hash = (hash << 5) - hash + char;
        hash &= hash;
    }

    return hash;
}
